import * as React from 'react'

import { configAdvertiserDisclosureCopySelector } from 'embed/selectors/config'
import { AD_DISCLOSURE_TITLE } from 'embed/constants'
import { connect } from 'react-redux'
import { CommonState } from 'embed/reducers'

const AdvertiserDisclosureContent = ({ copy }: { copy: string }) => (
  <>
    <p>
      <strong>{AD_DISCLOSURE_TITLE}</strong>
    </p>
    <p>{copy}</p>
  </>
)

const mapStateToProps = (state: CommonState) => ({
  copy: configAdvertiserDisclosureCopySelector(state),
})

export default connect(mapStateToProps)(AdvertiserDisclosureContent)
